import React from "react";
import { Route, Routes } from "react-router-dom";
import { Container, Row, Col } from "shards-react";

import MainNavbar from "./MainNavbar/MainNavbar";
import MainSidebar from "./MainSidebar/MainSidebar";
import UserSidebar from "./MainSidebar/UserSidebar";
import SuperAdminSidebar from "./MainSidebar/SuperAdminSidebar";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScaleLoader from "react-spinners/ScaleLoader";

import { Offline } from "react-detect-offline";
import SessionTimeoutWarning from "../shared/SessionTimeout/SessionTimeoutWarning";

// Poll our own backend so "offline" is not triggered by corporate firewall blocking httpbin.org
const healthUrl =
  (typeof window !== "undefined" && window.location?.origin)
    ? `${window.location.origin}${process.env.REACT_APP_SUB_DOMAIN || ""}/health`
    : "/health";
const offlinePolling = {
  enabled: true,
  url: healthUrl,
  timeout: 10000,
  interval: 15000,
};

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#004A7C",
  position: "fixed",
  height: "100%",
  width: "100%",
  opacity: "0.8",
  backgroundColor: "#000",
  zIndex: "9999",
  marginLeft: "-15px",
  paddingTop: "20%",
  paddingLeft: "50%",
};

const DefaultLayout = ({
  appState,
  auth,
  userRoles,
  authRoutes,
  superadminRoutes,
  adminRoutes,
  userRoutes,
}) => {
  const menuVisible = appState.menuVisible !== false;

  const lg_size = menuVisible ? 10 : 12;
  const lg_offset = menuVisible ? 2 : 0;
  const md_size = menuVisible ? 9 : 12;
  const md_offset = menuVisible ? 3 : 0;

  return (
    <Container fluid>
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Offline polling={offlinePolling}>
          <div className="alert alert-warning mb-0 rounded-0 text-center" role="alert">
            You&apos;re offline. Some features may be unavailable.
          </div>
        </Offline>
        {auth.authToken && auth.isLoggedIn && <SessionTimeoutWarning />}
        <ScaleLoader cssOverride={override} size={40} color={"#1484cd"} loading={appState.loading} speedMultiplier={1.5} />
        {auth.authToken ? (
          !auth.isLoggedIn ? (
            <ScaleLoader cssOverride={override} size={40} color={"#1484cd"} loading={true} speedMultiplier={1.5} />
          ) : auth.user && auth.user.role === userRoles.superadmin ? (
            <Row>
              <SuperAdminSidebar />
              <Col
                id="main-content"
                className="main-content p-0"
                lg={{ size: lg_size, offset: lg_offset }}
                md={{ size: md_size, offset: md_offset }}
                sm="12"
                tag="main"
              >
                <MainNavbar />
                <Routes>
                  {superadminRoutes.map((route, index) => (
                    <Route
                      key={"route-" + index}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Routes>
              </Col>
            </Row>
          ) : auth.user && auth.user.role === userRoles.admin ? (
            <Row>
              <MainSidebar />
              <Col
                id="main-content"
                className="main-content p-0"
                lg={{ size: lg_size, offset: lg_offset }}
                md={{ size: md_size, offset: md_offset }}
                sm="12"
                tag="main"
              >
                <MainNavbar />
                <Routes>
                  {adminRoutes.map((route, index) => (
                    <Route
                      key={"route-" + index}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Routes>
              </Col>
            </Row>
          ) : (
            <Row>
              <UserSidebar />
              <Col
                id="main-content"
                className="main-content p-0"
                lg={{ size: lg_size, offset: lg_offset }}
                md={{ size: md_size, offset: md_offset }}
                sm="12"
                tag="main"
              >
                <MainNavbar />
                <Routes>
                  {userRoutes.map((route, index) => (
                    <Route
                      key={"route-" + index}
                      path={route.path}
                      element={route.element}
                    />
                  ))}
                </Routes>
              </Col>
            </Row>
          )
        ) : (
          <Row>
            <Col className="" sm="12" tag="main">
              <Routes>
                {authRoutes.map((route, index) => (
                  <Route
                    key={"route-" + index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </Col>
          </Row>
        )}
        <ToastContainer />
      </Container>
  );
};

export default DefaultLayout;
